import { render, staticRenderFns } from "./DepartmentsSelection.vue?vue&type=template&id=e06e3610&"
import script from "./DepartmentsSelection.vue?vue&type=script&lang=js&"
export * from "./DepartmentsSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports